<template>
  <Navbar :title="NavbarTitle" :rightBtn="true"></Navbar>
  <div class="content-bg">
    <div class="header">
      <img class="img" src="@/assets/images/bg/bg_5@2x.png" />
      <div class="title" style="font-size: 16px">
        <!-- {{detail.industry}} -->
        {{ detail.title }}
      </div>
      <!-- <div class="origin" v-if="detail.origin">来源：{{ detail.origin }}</div> -->
      <div class="policy-file-item">
        <div class="policy-file-item-content">
          <div class="flex policy-file-item-title" style="font-weight: 400">
            <div class="flex-item">
              <div class="">
                <span
                  class="level"
                  v-if="detail.policy_level && detail.policy_level == 0"
                  >国</span
                >
                <span
                  class="level"
                  v-if="detail.policy_level && detail.policy_level == 1"
                  >省</span
                >
                <span
                  class="level"
                  v-if="detail.policy_level && detail.policy_level == 2"
                  >市</span
                >
                <span
                  class="level"
                  v-if="detail.policy_level && detail.policy_level == 3"
                  >区县</span
                >
                <span
                  class="level"
                  v-if="detail.policy_level && detail.policy_level > 3"
                  >其他</span
                >
                <span>来源：{{ detail.origin }}</span>
                <!-- <span class="level-right">匹配度：</span> -->
              </div>
            </div>
            <div class="btn-boxs" v-if="matchType == '1'">
              <div class="favorite">
                <span class="num">{{ matchingDegree }}%</span>匹配度
              </div>
            </div>
          </div>
          <div class="policy-file-item-tags with-row-gap">
            <span
              class="tag"
              v-for="(item, index) in detail.policyTopic"
              :key="item"
              :class="'tag_' + index"
            >
              {{ item }}
            </span>
          </div>
          <div class="policy-file-item-result">
            <div class="flex-item">阅读量:{{ detail.click_num || 0 }}</div>

            <div class="flex-item result-f" style="margin-left: 10px">
              收藏量:{{ detail.favorite_num || 0 }}
            </div>
          </div>
          <div class="policy-file-item-result" v-if="detail.dateView">
            <div class="flex-item">申报时间:{{ detail.dateView }}</div>
          </div>
          <div class="policy-file-item-result" v-else>
            <div class="flex-item" v-if="detail.startDate">开始时间:{{ detail.startDate }}</div>
            <div class="flex-item" v-if="detail.endDate" style="margin-left: 10px">
              结束时间:{{ detail.endDate  }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs-box">
      <van-tabs
        class="tab_1"
        v-model:active="activeTabs"
        @click-tab="changeTabs"
      >
        <van-tab
          v-for="(item, index) in tabs"
          :key="item"
          :title="item.title"
          :name="item.id"
        >
        </van-tab>
      </van-tabs>
    </div>
    <div class="tabs-content" v-if="activeTabs == 'sn_1'">
      <div class="card" v-for="item in items" :key="item.title">
        <div v-if="item.content">
          <div class="card-title">
            <div class="flex-title-text">
              {{ item.title }}
            </div>
          </div>
          <div class="card-content card-content-html" v-if="item.content">
            <div v-html="item.content"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs-content" v-if="activeTabs == 'sn_2'">
      <div class="card card-table">
        <table class="table" cellspacing="0">
          <thead>
            <tr>
              <th>要求</th>
              <th>满足状态</th>
              <th>操作</th>
            </tr>
          </thead>
            <van-popup v-model:show="show" style="width:320px;height:152px; border-radius: 20px;padding-top:20px">
                <van-field v-model="value" :placeholder="'请输入'+editItem.n+'金额（单位：万）'" />
                <van-button class="van-button1" style="color:rgb(9, 187, 7)"  @click.stop="changebtn">确认</van-button>
            </van-popup>
              <van-popup v-model:show="show2" position="bottom">
                  <van-datetime-picker type="datetime"  title="选择申报时间"  :formatter="formatter" @confirm="onConfirmDate" :min-date="minDate" @cancel="show2 = false" />
              </van-popup>
              <van-popup  v-model:show="show3">
                <van-radio-group v-model="checked" direction="horizontal" >
                  <van-radio name="1">1人</van-radio>
                  <van-radio name="2">2人及以上</van-radio>
                </van-radio-group>
                <van-button type="success" @click.stop="changebtn1">确认</van-button>
              </van-popup>
          <tbody>
            <tr    v-for="item in extend_data" :key="item.id" >
              <td>{{ item.n }}</td>
              <td v-if="item.type ==1">
                <van-icon
                  class="icon"
                  name="passed"
                  size="10"
                  color="#24CAA4"
                />
                <span>满足</span>
              </td>
              <td v-if="item.type !=1">
                <van-icon
                  class="icon"
                  name="close"
                  size="10"
                  color="#FF5019"
                />
                <span >不满足</span>
              </td>
              <td>
                <span class="table-icon1"  v-if="item.type !=1" @click="changenum(item)">修改</span
                >
                <span class="table-icon2"  @click="doDeclare"
                  >寻找服务商协助</span
                >
              </td>
            </tr>
            <tr   v-if="aTags.length>0"  v-for="item  in  aTags" :key="item">
                <td > {{item.name}}行业 </td>
                <td  v-if="companys.includes(item.id.toString())"> <van-icon
                  class="icon"
                  name="passed"
                  size="10"
                  color="#24CAA4"
                />
                <span>满足</span>
                </td>
               
                <td v-else>
                <van-icon
                  class="icon"
                  name="close"
                  size="10"
                  color="#FF5019"
                />
                <span >不满足</span>
              </td>
              <td>
                <span class="table-icon1" @click="changenum1(item.id)" v-if="!companys.includes(item.id.toString())">修改</span
                >
                <span class="table-icon2"  @click="doDeclare"
                  >寻找服务商协助</span
                >
              </td>
            </tr>
            <!-- <tr v-if="extend_data.length<2">
              <td> {{extend_data[0].n}} </td>
              <td>
                <van-icon
                  class="icon"
                  name="passed"
                  size="10"
                  color="#24CAA4"
                />
                满足
              </td>
              <td>
                <span class="table-icon1" @click="changenum(item.t)">修改</span
                ><span class="table-icon2" @click="clickPhone"
                  >寻找服务商协助</span
                >
              </td>
            </tr> -->
          </tbody>
        </table>
      </div>

      <div class="card" v-if="detail.article && detail.article.source">
        <div>
          <div class="card-title">
            <div class="flex-title-text">联系方式</div>
          </div>
          <div class="card-content">
            <span>联系人： {{ detail.contact_phone }} </span>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="detail.article && detail.article.source">
      <div>
        <div class="card-title">
          <div class="flex-title-text">文章来源</div>
        </div>

        <div class="card-content">
          <div>
            <a :href="detail.article.source" target="_blank">{{
              detail.title
            }}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="appendix.length">
      <div class="card-title">
        <div class="flex-title-text">附件</div>
      </div>

      <div class="card-content">
        <div v-for="item in appendix" :key="item">
          <a :href="item.contentView" target="_blank">{{ item.name }}</a>
        </div>
      </div>
    </div>

      <div class="article-kv-card" v-for="item in articleKvList" :key="item">
        <div
          class="article-kv-card-title"
          style="margin: 0; padding-bottom: 0"
          v-if="item.key && item.key.replace('：','').length > 1"
        >
          {{ item.key }}
        </div>
        <div style="margin: 0; padding: 0 0.4rem 0.4rem">
          <div class="article-kv-card-content" v-for="v in item.value" :key="v">
            <div  v-if="v && v.length > 1">{{ v }}</div>
          </div>
          <div v-if="item.children && item.children.length">
            <div v-for="k in item.children" :key="k">
              <div style="font-weight: bold; padding: 18px 0 8px" v-if="k.key && k.key.replace('：','').length > 1">
                {{ k.key }}
              </div>
              <div
                class="article-kv-card-content"
                v-for="v in k.value"
                :key="v"
                style="margin: 0; line-height: 1.8"
              >
                <div  v-if="v && v.length > 1">{{ v }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card similar" v-if="similar.length">
        <Similar :similar="similar"></Similar>
      </div>
  </div>

  <!-- <div class="float-action">
        <div class="flex-item btn-collect-box" v-if="btnType != '2'">
            <van-button class="btn btn-collect btn-favorite" v-if="!favorite" @click="doFav(true)">
                <img class="icon-favorite" src="@/assets/images/icon_favorite_1@2x.png">
                收藏
            </van-button>
            <van-button class="btn btn-favorite-active" v-else @click="doFav(false)">
                <img class="icon-favorite" src="@/assets/images/icon_favorite_2@2x.png">

                取消收藏
            </van-button>
        </div>
        <div class="flex-item btn-consult-box" v-if="btnType == '1' && detail.status == '1'">
            <van-button class="btn btn-consult" @click="doDeclare">
                <van-icon class="icon" name="chat-o" color="#fff" size="20" />
                一键申报
            </van-button>
        </div>
        <div class="flex-item btn-consult-box" v-if="btnType == '2'">
            <van-button class="btn" type="danger" @click="doTel">联系服务商</van-button>
        </div>
    </div> -->

  <div class="float-action">
    <div class="flex-item" v-if="btnType == '1' && detail.statusView == '1'">
      <van-button class="btn" @click="doDeclare">
        <img class="icon" src="@/assets/images/match/icon_5@2x.png" />
        服务商申报
      </van-button>
    </div>
    <div class="flex-item btn-ukey-box" v-if="btnType != '2'">
      <van-button class="btn" @click="doDeclareKey">
        <img class="icon" src="@/assets/images/match/btn_declare@2x.png" />
        一键申报(VIP)
      </van-button>
    </div>
    <div class="flex-item" v-if="btnType == '2'">
      <van-button class="btn" type="danger" @click="doTel"
        >联系服务商</van-button
      >
    </div>
  </div>

  <div v-if="declareShow">
    <declare-model
      :show="declareShow"
      :list="declareList"
      @declareSelected="declareSelected"
      @closeDeclare="closeDeclare"
    ></declare-model>
  </div>
</template>

<script>
import { Dialog, Notify } from "vant";
import {
  queryById,
  queryOrderById,
  getServiceProviderList,
  addFavorite,
  cancelFavorite,
  queryFavorite,
  queryUserById,
  queryDeclareInfov3,
  queryDeclareInfov3change,
  getArticleKvV3,
  getArticleSimilarV3,
  queryDeclareInfov4
} from "@/api/home";
import moment from "moment";
import { info, cache, ws } from "@/api";
import Select from "@/components/Select.vue";
import SearchDetail from "@/components/SearchDetail.vue";
import Area from "@/components/Area.vue";
import Navbar from "@/components/Navbar";
import PolicyDetailHeader from "@/components/PolicyDetailHeader.vue";
import DeclareModel from "@/components/DeclareModel";
import { clickUrlToPhone, clickUrl } from "@/utils/index";
import { getUserInfo, getUserId } from "@/utils/storage";
import store from "@/store";
import Similar from "./comp/similar.vue";

export default {
  name: "DeclareDetail",
  data() {
    return {
      detail: {
        serviceProviderTel: "",
      },
      items: [],
      show: false,
      show2: false,
      show3: false,
      list: [],
      declareShow: false,
      formCompany: {},
      showCompany: false,
      declareList: [],
      NavbarTitle: "政策申报详情",
      btnType: 0,
      favorite: false,
      queryCompany: {},
      company: {},
      value: "",
      value1: "",
      iptvalue: "500",
      matchingDegree: "",
      matchType: 0,
      activeTabs: "sn_2",
      content: 1,
      showTwoTime: true,
      formSearch:{},
      checked:0,
      moneyScopeMin:0,
      moneyScopeMax:0,
      yy:1,
      mm:1,
      dd:1,
      type:2,
      aTags:[],
      companys: [],
      extend_data: [
        // { e: 100000, g: 100000, id: "36", l: 100000, n: "博士人数", t: 3 },
      ],
      minDate: new Date("1949/01/01"),
      tabs: [
        { title: "申报匹配项", id: "sn_2" },
        { title: "政策内容", id: "sn_1" },
      ],
      articleKvList: [],
      appendix: [], //附件
      similar: [], //相似文件
      editItem: {}
    };
  },
  components: {
    Select,
    SearchDetail,
    Area,
    Navbar,
    PolicyDetailHeader,
    DeclareModel,
    Similar,
  },
  computed: {},
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    clickPhone() {
      Dialog.confirm({
        title: "提示",
        message: "确定拨打电话：010-xxxxxx吗？",
        confirmButtonColor: "#09BB07",
      })
        .then(() => {
          // on confirm
          this.$refs.telPhone.click();
        })
        .catch(() => {
          // on cancel
        });
    },
    
    async  onConfirmDate(value) {
            this.formSearch.register_date = moment(value).format('YYYY-MM-DD HH:mm:ss')
            this.show2 = false
            console.log(this.formSearch.register_date);
            
            console.log(this.yy);
            let att =  JSON.parse(this.detail.extend_data)
            att[49].g = this.formSearch.register_date
            console.log(JSON.stringify(att));
      console.log(JSON.stringify(this.detail.extend_data));
      try {
        let res = await queryDeclareInfov3change({
          extend_data : JSON.stringify(att)
        })
        console.log(res);
        this.editSucCallBack()    
      } catch {
              
      } finally {
        this.show2 = false 
      } 
    },
    editSucCallBack() {
      var that = this
      that.$toast.success({ message: '提交成功', duration: 2000 })
        setTimeout(() => {
          that.extend_data = []
          that.companys = []
          that.getData()
        },2000)
    },
    async onNameDialogBeforeClose1(action, done, e) {
      console.log(e);
      // action的值: confirm或cancel(点击按钮区分)
      if (action === "confirm" && e == 1) {
        if (this.value.length > 0) {
          this.iptvalue = this.value;
          this.show = false;
        } else {
          this.show = false;
        }
      } else if (action === "cancel") {
        // 取消
        this.show = false;
      }
    },
    changenum(item) {
      this.editItem = item
      let e = item.t
      if (e == 1) {
        this.show2 = true;
        console.log(1);
        this.show = false;
      } else if (e == 2) {
        console.log(2);
        this.show = !this.show;
      } else if (e == 3) {
        this.show3 = !this.show3;
      }
    },
    async changenum1(e) {
     console.log(e);
      let arr = this.companys
     arr.push(e)
      let tags = arr.join(',')
      try {
        let res = await queryDeclareInfov4({ tags: tags })
        this.editSucCallBack()
      } catch {
        
      }
     
    },
    confirm() {
      console.log(1);
    },
    numbtn(e) {
      this.iptvalue = this.value;
      this.show = false;
    },
    init() {
      this.id = this.$route.query.id;
      this.btnType = this.$route.query.btnType;
      this.type = this.$route.query.type || "";
      this.matchType = this.$route.query.matchType;
      this.articleId = this.$route.query.articleId;
      if (this.$route.query.matchType) {
        this.matchingDegree = this.$route.query.matchingDegree;
      }
      this.getData();
      this.getDeclareList();
      console.log(this.$route.query);
      this.getArticleKv();
    },
    async doFav(type) {
      const request = type ? addFavorite : cancelFavorite;
      let res = await request({ declare_id: this.id });
      this.$toast.success({
        message: type ? "收藏成功" : "取消收藏成功",
        duration: 2000,
      });
      setTimeout(() => {
        this.getData();
      }, 2000);
    },
    async changebtn() {
      if (!this.value.length) {
        this.$toast('请输入'+this.editItem.n)
        return false
      }
      if (JSON.parse(this.detail.extend_data)[44] && this.value.length>0) {
        console.log(this.value.length);
        let att = JSON.parse(this.detail.extend_data);
        att[44].g = this.value * 10000;
        att[44].e = this.value * 10000;
        att[44].l = this.value * 10000;
        console.log(JSON.stringify(att));
        // console.log(JSON.stringify(this.detail.extend_data) );
        let res = await queryDeclareInfov3change({
          extend_data: JSON.stringify(att),
        });
        this.show = false
        this.editSucCallBack()
      } else if (JSON.parse(this.detail.extend_data)[6] && this.value.length>0) {
        let att = JSON.parse(this.detail.extend_data);
        att[6].g = this.value * 10000;
        att[6].e = this.value * 10000;
        att[6].l = this.value * 10000;
        console.log(JSON.stringify(att));
        // console.log(JSON.stringify(this.detail.extend_data) );
        let res = await queryDeclareInfov3change({
          extend_data: JSON.stringify(att),
        });
        this.show = false
        this.editSucCallBack()
      } else if (
        JSON.parse(this.detail.extend_data)[36] ||
        JSON.parse(this.detail.extend_data)[37]
      ) {
       this.show = false
      }
      
  this.detail.extend_data={}
      console.log(this.detail.extend_data);
    },
    async changebtn1(e) {
      console.log(this.checked);
      // let att =  JSON.parse(this.detail.extend_data)
      // console.log(att);

      // att[49].g = this.value1
      // console.log(JSON.stringify(att));
      // console.log(JSON.stringify(this.detail.extend_data) );
      // let res = await queryDeclareInfov3change({
      //      extend_data : JSON.stringify(att)
      // })
      // console.log(res);
      this.show3 = false;
    },
    async getData() {
      
      let res = await queryDeclareInfov3({
        id: this.id,
        articleId: this.articleId,
      });
      this.detail = res.result;
      if (res.result.title) {
        this.getArticleSimilar(res.result.title);
      }
      this.appendix = res.result.appendix.map((o) => {
        return {
          ...o,
          contentView: location.origin + "/" + o.content,
        };
      });
      let nowTime = new Date().getTime();
      let startTime = res.result.start_time
        ? moment(res.result.start_time).toDate().getTime()
        : "";
      let endTime = res.result.end_time
        ? moment(res.result.end_time).toDate().getTime()
        : "";
      let statusView = -1;
      if (endTime && nowTime >= endTime) {
        statusView = 0;
      } else if (startTime && nowTime < startTime) {
        statusView = 2;
      } else if (startTime && nowTime >= startTime) {
        statusView = 1;
      }
      this.detail.statusView = statusView;

      if (startTime && endTime && startTime == endTime) {
        this.detail.dateView = moment(res.result.start_time).format('YYYY-MM-DD')
      }
      this.detail.startDate = res.result.start_time ? moment(res.result.start_time).format('YYYY-MM-DD') : ''
      this.detail.endDate =  res.result.end_time ? moment(res.result.end_time).format('YYYY-MM-DD'): ''
     
      this.detail.article.aTags =  res.result.article.aTags || []
      this.aTags = res.result.article.aTags || []
      this.detail.origin = res.result.article.origin;
      this.companys = res.result.company.tags.split(',')
      console.log(626,this.companys)
      this.detail.dispatch_name = res.result.article.dispatch_name;
      this.detail.policy_level = res.result.article.policy_level;
      console.log(this.aTags);

      let extendDataArr = JSON.parse(this.detail.article.extend_data)
     let extendDataCompanyArr = JSON.parse(res.result.company.extend_data)
      // var extend_data = this.detail.extend_data
      console.log(extendDataArr);
      console.log(extendDataCompanyArr);
      // if (extendData[49] && extendData[44]) {
      //   this.extend_data = this.extend_data.concat(
      //     extendData[49]
      //   ).concat(extendData[44]);
      //   console.log(this.extend_data);
      // } else
      for (var i in extendDataArr) {
        let extendData = extendDataArr[i]
        extendData.type = 0
        console.log(i);
        if (i == 44) {
          let a_44 = extendData.e
          if(extendDataCompanyArr[i]){
            let c_44 = extendData ? extendDataCompanyArr[i].e : 0
            extendData.type = c_44 > a_44 ? 1 : 0
          }else{
            let c_44 =  0
            extendData.type = c_44 > a_44 ? 1 : 0
          }
        } else if (i == 49) {
          extendData.type = 0
          if(extendDataCompanyArr[i]){
          let _t = moment(extendData.e).toDate().getTime()
          let _st = moment(extendDataCompanyArr[i].e).toDate().getTime()
            if (_t < _st ) {
              extendData.type = 1
            }
          }else{
            let _t = moment(extendData.e).toDate().getTime()
            let _st = 0
            if (_t < _st ) {
              extendData.type = 1
            }
          }
        }
      
      this.extend_data = this.extend_data.concat(extendData)
      console.log(this.extend_data);
}
      console.log(this.extend_data);
      // console.log(extend_data.substring(extend_data.indexOf("id") ,extend_data.indexOf(",")));
      this.favorite = res.result.favorite ? true : false;
      this.detail.matchingDegree = this.getNum(
        res.result.article.matching_degree
      );
      this.detail.content = res.result.article.content;
      // console.log( res.result.article.content);
      this.items = [
        { title: "核心内容", content: res.result.article.content },
        // { title: '扶持条件', content: res.result.article.support_conditions },
        // { title: '申报材料', content: res.result.article.filing_materials },
        // { title: '申报流程', content: res.result.article.declaration_process },
        // { title: '联系方式', content: res.result.article.contact_phone },
        // { title: '政策文件', content: res.data.dispatchDepartment }
      ];

      let arr = [];
      if (res.result.article.dispatch_name)
        arr.push(res.result.article.dispatch_name);
      let moneyScopeMin =
        res.result.declare && res.result.declare.money_scope_max
          ? Math.floor(res.result.declare.money_scope_max) / 10000
          : 0;
      let moneyScopeMax =
        res.result.declare && res.result.declare.money_scope_min
          ? Math.floor(res.result.declare.money_scope_min) / 10000
          : 0;
      this.moneyScopeMax = moneyScopeMax;
      this.moneyScopeMin = moneyScopeMin;
      if (!(moneyScopeMin == 0 && moneyScopeMax == 0)) {
        moneyScope = moneyScopeMin + '-' + moneyScopeMax
      }
      let moneyScope = "资金扶持"
      if (moneyScopeMin == 0 && moneyScopeMax == 0) {
        moneyScope += '0万元'
      } else {
        moneyScope += moneyScopeMin + '-' + moneyScopeMax +'万元'
      }
      arr.push(moneyScope)
      this.detail.policyTopic = arr;
    },
    getNum(str) {
      let num = 0;
      if (str) {
        num = parseFloat(str * 100).toFixed(2);
      }
      return num;
    },
    async getDeclareList() {
      let res = await getServiceProviderList();
      this.declareList = res.result.data || [];
    },
    doDeclare() {
      this.declareShow = true;
    },
    declareSelected(arg) {
      this.declareShow = false;
      let query = {
        type: "getPhone",
        declare_id: this.id,
        serviceProviderId: arg.id,
      };
      clickUrlToPhone("", query);
    },
    closeDeclare() {
      this.declareShow = false;
    },
    changeTabs(val) {
      this.activeTabs = val.name;
      console.log(this.activeTabs);
    },
    async doDeclareKey() {
      var that = this;
      try {
        let res = await queryUserById();
        let e_time = res.result.expiration_time
          ? res.result.expiration_time.replace(/-/g, "/")
          : null;
        let expirationTime = new Date(e_time).getTime();
        let time = new Date().getTime();
        // let isVip = time < expirationTime ? true : false;
        let isVip = true;

        that.$dialog
          .confirm({
            message: isVip
              ? "请使用u-Key在PC端进行申报"
              : "该功能仅限VIP用户使用\n如需自主申报请开通VIP",
            showCancelButton: !isVip ? true : false,
            confirmButtonText: !isVip ? "去开通" : "确认",
          })
          .then(() => {
            if (!isVip) {
              clickUrl("/vip");
            }
          })
          .catch(() => {});
      } catch {}
    },
    async getArticleKv() {
      try {
        let res = await getArticleKvV3({
          id: this.articleId,
        });
        this.articleKvList = this.getArticleKvList(res.result, []);
      } catch {}
    },
    getArticleKvList(data, arr) {
      for (var i in data) {
        let obj = {
          key: data[i].key,
          children: [],
          value: data[i].value,
        };
        if (data[i].children) {
          this.getArticleKvList(data[i].children, obj.children);
        }
        arr.push(obj);
      }
      return arr;
    },
    async getArticleSimilar(title) {
      try {
        let res = await getArticleSimilarV3({ title: title });
        this.similar = res.result || [];
      } catch {}
    },
  },
  beforeRouteLeave(to, from, next) {
    // 离开的时候，非以下页面则删除缓存组件 name
    // 记录路由处的name值
    let coms = ["PolicyQuery", "SearchResult"];
    console.log(coms.indexOf(to.name) === -1, to.name);
    if (coms.indexOf(to.name) === -1) {
      for (var i in coms) {
        store.commit("REMOVE_KEEP_ALIVE_COM", coms[i]);
      }
    }

    next();
  },
};
</script>

<style lang="scss" scoped>
.content-bg {
  padding: 0 0 80px;
}
.header {
  .img {
    top: 0;
    z-index: -1;
    height: 85%;
  }
  .title {
    color: #fff;
    font-size: 32px;
    font-weight: 600;
    margin: 50px 25px 10px;
    display: flex;
    align-items: center;
  }
  .origin {
    margin: 3px 10px 5px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 14px;
    -webkit-background-clip: text;
  }
  .policy-file-item {
    margin: 0 20px;
  }
}
.card {
  width: auto;
  margin: 0 10px 12px;
  background: #fff;
  border-radius: 8px;
  > div {
    padding: 10px 15px;
  }
  .card-title {
    margin: 0;
    font-size: 14px;
    &:before {
      border-left: 4px solid #0c9de9;
    }
    &:first-of-type {
      border: 0;
    }
  }
  .card-content {
    margin: 10px 0 0;
    padding: 0;
    color: #666;
  }
}
.policy-file-item {
  box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  margin: 20px 0 12px;

  .level {
    width: 20px;
    padding: 1px;
    background: #1989fa;
    color: #fff;
    border-radius: 4px;
    font-weight: 400;
    margin-right: 5px;
  }
  .level-right {
    margin-left: 40%;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #555555;
    line-height: 14px;
  }

  .tag {
    padding: 0 3px;
    color: #000;
    border-radius: 4px;
    font-weight: 400;
    margin-right: 5px;

    &.tag_0 {
      background: #d8f4f0;
      border: 1px solid #33978b;
    }

    &.tag_1 {
      background: rgba(139, 184, 213, 0.35);
      border: 1px solid #8bb8d5;
    }
  }
}
.policy-file-item-result {
  display: flex;
  justify-content: space-between;
  color: #999;
  line-height: 20px;

  .result-f {
    color: #fff;
    background: #ff642e;
    padding: 2px 3px;
    border-radius: 4px;
    line-height: 15px;
  }
}

.color-1 {
  color: #ff642e;
}
.num {
  font-size: 24px;
  font-weight: 600;
  color: #ff642e;
}
.source {
  color: #fff;
  margin: 3px 0 5px;
}

.tabs-box {
  margin: 0 16px;
}
.tabs-content {
  margin-bottom: 12px;
}
::v-deep .van-tabs__nav {
  background: #e7e7e7;
  border-radius: 8px;
  .van-tab {
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.4);
    line-height: 16px;
    &--active {
      background: #fff;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      .van-tab__text {
        color: rgba(0, 0, 0, 0.8) !important;
      }
    }
  }
}

.card-table {
  padding: 10px 6px 20px;
}
.table {
  width: 100%;
  background: #fff;
  .table-icon1 {
    background: #1989fa;
    border-radius: 2px 2px 2px 2px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 14px;
    margin-right: 4px;
    padding: 1px;
  }
  .table-icon2 {
    background: #24caa4;
    border-radius: 2px 2px 2px 2px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 14px;
    padding: 1px;
  }
}
th {
  background: rgba(207, 236, 255, 0.6);
}
td,
th {
  line-height: 40px;
  text-align: center;
}
tbody td {
  border-bottom: 1px solid rgba(207, 236, 255, 0.5);
  .icon {
    margin-right: 3px;
    vertical-align: middle;
  }
}

.float-action {
  height: auto;
  .flex-item {
    display: flex;
    align-items: center;
    .btn {
      border-radius: 20px;
      height: 42px !important;
      line-height: 43px;
      color: #fff;
      border: 1px solid transparent;
      margin: 5px 0 10px !important;
      .icon {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        background-size: 100% 100%;
      }
    }
  }
}

.btn-ukey-box {
  margin-left: 5px;
  .btn {
    background: linear-gradient(
      94deg,
      #24caa4 0%,
      #1fbc98 100%,
      rgba(36, 202, 164, 0) 100%
    );
  }
}
::v-deep .tab_1 {
  .van-tab:first-of-type {
    &.van-tab--active::after {
      position: absolute;
      content: "";
      width: 8px;
      height: 8px;
      line-height: 10px;
      display: block;
      text-align: center;
      background-image: radial-gradient(20px at 8px 0px, #e7e7e7 8px, #fff 8px);
      bottom: 0px;
      right: -8px;
    }
  }

  .van-tab:nth-last-of-type(2) {
    &.van-tab--active::after {
      position: absolute;
      content: "";
      width: 8px;
      height: 8px;
      line-height: 8px;
      display: block;
      text-align: center;
      background-image: radial-gradient(20px at 0px 0px, #e7e7e7 8px, #fff 8px);
      bottom: 0;
      left: -8px;
    }
  }
}
.title-icon {
  width: 100%;
  height: 40px;
  display: flex;
  flex-wrap: wrap;
}
.title-icon1 {
  padding: px;
  height: 15px;
  background: #d8f4f0;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #33978b;
  font-size: 10px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 12px;
  margin-right: 4px;
}
.title-icon2 {
  font-size: 10px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 12px;
  height: 15px;
  background: rgba(139, 184, 213, 0.35);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #8bb8d5;
}
.popup {
  width: 200px !important;
  height: 120px !important;
}
/* .van-button--success {
  margin-left: 40%;
  margin-top: 80px;
} */
.origin {
  color: #fff;
  font-size: 12px;
  margin: 0.08rem 0.66667rem 0.13333rem !important;
}
.van-cell {
  top: 10%;
  left:12%;
  width: 250px;
height: 40px;
border-radius: 4px 4px 4px 4px;
opacity: 1;
border: 1px solid rgba(35, 199, 162, 0.2);
}
.van-button1 {
  height: 40px !important;
  width:100% !important;
  margin-top: 60px !important;
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 20px !important;
}

.article-kv-card {
  width: auto;
  margin: 0 10px 12px;
  background: #fff;
  border-radius: 8px;
  > div {
    padding: 10px 15px;
  }
  .article-kv-card-title {
    margin: 0;
    font-size: 14px;
    &:before {
      content: "";
      height: 16px;
      margin-right: 5px;
      border-left: 4px solid #0c9de9;
    }
    &:first-of-type {
      border: 0;
    }
  }
  .article-kv-card-content {
    margin: 10px 0 0;
    padding: 0;
    color: #666;
  }
}
.van-popup--center {
  width: 200px !important;
  height: 100px !important;
  border-radius: 5px;
}
</style>
<style>
.similar .card-title{
  padding: 10px 15px 0;
}
</style>
